<template>
  <div>
    <div>
      <router-link to="/">Home</router-link>
      <label class="labelBar"> / </label>
      <label> Cadastro/Produtos e Serviços/Condição Pagamento</label>
    </div>
    <tab-navegacao :active_tab="active_tab" />
    <v-container fluid
      ><v-row align="center">
        <v-col>
          <v-btn
            color="info"
            to="/condicaoPagamento/criar"
            v-if="isAllowed(6)"
            class="ma-2 white--text"
          >
            NOVO
          </v-btn>
        </v-col>
        <v-col class="text-right">
          <v-checkbox
            v-if="condicoes.length > 0"
            v-model="showAtivo"
            label="MOSTRAR ITENS INATIVOS"
          ></v-checkbox>
        </v-col>
        <v-col class="text-right">
          <v-btn
            @click="baixarlista()"
            v-if="condicoes.length > 0"
            class="ma-2 blue--text"
            align="right"
          >
            <v-icon>mdi-file-excel</v-icon>
            Baixar planilha
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
    <v-card>
      <v-card-title>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Pesquisar"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="filteredList"
        :loading="loading"
        loading-text="Buscando dados..."
        :search="search"
        :footer-props="{
          showFirstLastPage: true,
          itemsPerPageText: 'Items por página',
          itemsPerPageOptions: [5, 10, 15, -1],
        }"
      >
        <template v-slot:item.ativo="{ item }">
          {{ item.ativo ? "Ativo" : "Inativo" }}
        </template>
        <template v-slot:item.requisicao="{ item }">
          {{ item.requisicao ? "Sim" : "Não" }}
        </template>
        <template v-slot:item.actions="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="primary"
                class="mr-2"
                @click="editar(item)"
                v-bind="attrs"
                v-on="on"
              >
                mdi-pencil
              </v-icon>
            </template>
            <span v-if="isAllowed(6)">Editar</span>
            <span v-else>Ver</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import TabNavegacaoProduto from "../../Tabs/TabCadastroProduto";
import { getUserRoles } from "@/services/loginService";

export default {
  name: "listaCondicoesPagamento",
  data() {
    return {
      loading: false,
      search: "",
      showAtivo: false,
      active_tab: 2,
      headers: [
        {
          text: "Id", align: "start", value: "id",
        },
        { text: "Descrição", value: "descricao" },
        { text: "Status", value: "ativo" },
        { text: "Ações", value: "actions", sortable: false },
      ],
      filters: {
        descricao: [],
      },
    };
  },
  computed: {
    ...mapState("condicaoPagamento", ["condicoes"]),
    filteredList() {
      if (this.showAtivo === false) {
        var newList = this.condicoes.filter((cp) => {
          return (
            cp.descricao.toLowerCase().includes(this.search.toLowerCase()) &&
            cp.ativo === true
          );
        });
        return newList.filter((d) => {
          return Object.keys(this.filters).every((f) => {
            return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
          });
        }).sort( function ( a, b ) { return b.id - a.id; } );
      } else {
        var novaLista = this.condicoes.filter((cp) => {
          return cp.descricao.toLowerCase().includes(this.search.toLowerCase());
        });
        return novaLista.filter((cp) => {
          return Object.keys(this.filters).every((f) => {
            return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
          });
        }).sort( function ( a, b ) { return b.id - a.id; } );
      }
    },
  },
  methods: {
    ...mapActions("condicaoPagamento", ["atualizarCondicoes", "atualizarCondicao"]),
    editar(condicao) {
      this.atualizarCondicao(condicao);
      if (this.isAllowed(6)) {
        this.$router.push(`/condicaoPagamento/editar`);
      } else {
        this.$router.push(`/condicaoPagamento/ver`);
      }
    },
    baixarlista() {
      //downloadLista();
      
      const blob = this.gerarExcel();
      const nome_arquivo = "condicoesPagamento.xlsx";
      saveAs(blob, nome_arquivo);
    },
    async obterLista() {
      this.loading = true;
      await this.atualizarCondicoes();
      this.loading = false;
    },
    isAllowed(id) {
      var regra = this.regras.find((r) => {
        return r.idModulo == id;
      });
      return regra != null && regra.escrita;
    },
    columnValueList(val) {
      return this.filteredList.map((d) => d[val]);
    },
    
    gerarExcel() {
      const colunas = [
        { chave: "id", cabecalho: "Id" },
        { chave: "descricao", cabecalho: "Condição Pagamento" },
        { chave: "status", cabecalho: "Status" },
      ];

      const aoa = [];

      aoa.push(colunas.map((c) => c.cabecalho));

      this.filteredList.forEach((item) => {
        aoa.push(
          colunas.map((c) => {
            if (c.chave === "id") {
              return item[c.chave] === 0 ? "" : item[c.chave];
            } else {
              return item[c.chave];
            }
          })
        );
      });

      const ws = window.XLSX.utils.aoa_to_sheet(aoa);

      const larguras = colunas.map((col, i) => {
        const valores = [
          col.cabecalho,
          ...this.filteredList.map((d) => String(d[col.chave])),
        ];
        const larguraMaxima = Math.max(...valores.map((v) => v.length)) + 2;
        return { wch: larguraMaxima };
      });
      ws["!cols"] = larguras;

      const headerStyle = {
        font: { bold: true },
        alignment: { horizontal: "center" },
      };
      colunas.forEach((col, index) => {
        const colLetra = String.fromCharCode(65 + index); // A, B, C...
        const cell = ws[`${colLetra}1`];
        if (cell) cell.s = headerStyle;
      });
      const wb = window.XLSX.utils.book_new();
      window.XLSX.utils.book_append_sheet(wb, ws, "Planilha");

      const wbout = window.XLSX.write(wb, {
        bookType: "xlsx",
        type: "array",
        cellStyles: true,
      });

      return new Blob([wbout], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
    },
  },
  created: function () {
    this.obterLista();
    var roles = getUserRoles();
    if (roles) {
      this.regras = roles;
    }
  },
  components: {
    TabNavegacaoProduto,
  },
};
</script>
